






































































import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import WorkingTimeMixin from '@/mixin/WorkingTime/WorkingTimeMixin';
import { StaffEntity } from '@/entities/staff.entity';
import { TranslateResult } from 'vue-i18n';
import DialogDailyReport from '@/components/ViewComponent/Attendance/DialogDailyReport.vue';

type WorkingTimeActions =
  | 'checkin'
  | 'checkout'
  | 'pauseWorking'
  | 'continueWorking';

@Component<WorkingTimeTracker>({
  components: { DialogDailyReport },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class WorkingTimeTracker extends WorkingTimeMixin {
  currentStaff!: StaffEntity;
  showDialog = false;
  async callActionAndShowDialog(action: WorkingTimeActions): Promise<void> {
    await this[action]();
    this.showDialog = true;
  }

  get currentTitle(): TranslateResult {
    let text = this.$t('navbar.working.start');
    if (this.currentStaff.checkInTime) {
      text = this.$t('navbar.working.start');
    }
    if (
      this.currentStaff.checkInTime &&
      !this.currentStaff.checkOutTime &&
      !this.currentStaff.isPause &&
      this.currentStaff.workingTimes[0].breakingTimes.length
    ) {
      text = this.$t('navbar.working.finishBreak');
    }
    if (this.currentStaff.isPause) {
      text = this.$t('navbar.working.startBreak');
    }
    if (this.currentStaff.checkOutTime) {
      text = this.$t('navbar.working.stop');
    }
    return text;
  }
  get isDisableButtonStartWorkingTime(): boolean {
    return !!this.currentStaff.checkInTime;
  }
  get isDisableButtonBreakTime(): boolean {
    return !(
      this.currentStaff.checkInTime &&
      !this.currentStaff.checkOutTime &&
      !this.currentStaff.isPause
    );
  }
  get isDisableButtonFinishBreakTime(): boolean {
    return !this.currentStaff.isPause;
  }
  get isDisableButtonStopWorkingTime(): boolean {
    return !(this.currentStaff.checkInTime && !this.currentStaff.checkOutTime);
  }
}
